import { ComponentProps, FC } from 'react';
import type { ButtonProps } from 'antd';
import { TbDirection } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

type DropdownButtonIconProps = ComponentProps<typeof TbDirection> & {
    buttonType?: ButtonProps['type'];
};

const DropdownButtonIcon: FC<DropdownButtonIconProps> = ({ buttonType, size = '1rem', style, ...props }) => {
    const { token } = useAntDesignTheme();
    const color = buttonType === 'primary' ? token.colorTextLightSolid : token.colorTextTertiary;

    return <TbDirection {...props} size={size} style={{ color, verticalAlign: '-0.175rem', ...style }} />;
};

export default DropdownButtonIcon;
